import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router';

import ResourceTooltip from '@src/components/common/Display/ResourceTooltip/ResourceTooltip';
import StatusLabels from '@src/components/common/Display/titles/StatusLabels';
import { resourceURLByType } from '@src/utils/urlHelpers';

import './FeaturedTrainingsAndJobAids.scss';

const calculateOddOrEven = (indexNumber) => {
    return Math.floor(indexNumber % 2) === 0 ? 'even' : 'odd';
};

const FeaturedTrainingsAndJobAids = ({ items }) => {
    if (!items || items.length === 0) {
        return null;
    }

    return (
        <Row className="featured-trainings-job-aids-table-container training-row main-container-row">
            <Col className="featured-trainings-job-aids-table-inner">
                <div className="ml-table-container">
                    <ul className="featured-trainings-list">
                        {
                            items.map((item, i) => {
                                const itemLink = resourceURLByType(item);

                                return (
                                    <li
                                        key={`featured-job-aid-${item.id}`}
                                        className={`featured-trainings-item ${calculateOddOrEven(i)}`}
                                    >
                                        <ResourceTooltip
                                            publishedAt={item.published_at}
                                            updatedAt={item.updated_at}
                                            isUpdated={item.is_updated}
                                            effectiveFrom={item.effective_from}
                                            products={item.products}
                                            states={item.states}
                                            agents={item.agents}
                                            resourceType="job_aid"
                                            resourceId={item.id}
                                            placement="right"
                                        />
                                        <StatusLabels expiredAt={item.expired_at} />
                                        <Link
                                            to={itemLink}
                                            className="link-primary"
                                            title={item.title}
                                            aria-label={item.title}
                                        >
                                            {item.title}
                                        </Link>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            </Col>
        </Row>
    );
};

FeaturedTrainingsAndJobAids.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        published_at: PropTypes.string,
        updated_at: PropTypes.string,
        is_updated: PropTypes.bool,
        effective_from: PropTypes.string,
        expired_at: PropTypes.string,
        products: PropTypes.arrayOf(PropTypes.object),
        states: PropTypes.arrayOf(PropTypes.object),
        agents: PropTypes.string,
        urlPrefix: PropTypes.string,
        record_type: PropTypes.string,
    })).isRequired,
};

export default React.memo(FeaturedTrainingsAndJobAids);

